<template>
  <div class="house-importer-check-source-stage" v-if="loading === false">
    <CheckSourceStageSidebar :importInfo="importInfo" class="house-importer-check-source-stage__sidebar"/>

    <CheckSourceStageInfo class="house-importer-check-source-stage__info" :importInfo="importInfo"/>

    <CheckSourceStageChanges class="house-importer-check-source-stage__changes" :importInfo="importInfo" @set-loading="loading = $event"/>
  </div>
  <div v-else-if="loading === true" class="content-full-page import-source-stage-post-sending" >
    <div class="block-loading" />
    {{importInfo.status ? importInfo.status : 'Импортируем файлы...'}}
  </div>
</template>

<script>
  import CheckSourceStageSidebar from "./check-source-stage/CheckSourceStageSidebar";
  import CheckSourceStageChanges from "./check-source-stage/CheckSourceStageChanges";
  import CheckSourceStageInfo from "./check-source-stage/CheckSourceStageInfo";


  export default {
    name: "CheckSourceStage",
    components: {
      CheckSourceStageSidebar,
      CheckSourceStageChanges,
      CheckSourceStageInfo
    },
    props: {
      importInfo: {}
    },
    data(){
      return {
        loading: false
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-check-source-stage{
    padding-left: 435px;

    &__sidebar{
      position: fixed;
      left: 15px;
    }

    &__info, &__changes{
      margin-bottom: 15px;
    }
  }

  .import-source-stage-post-sending{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading{
      width: 100px;
      height: 100px;
      flex: 0;
      margin-bottom: 15px;
    }
  }

</style>